/**
 * Renders the description including individual paragraphs and linebreaks.
 *
 * @param {string || null || undefined} description
 * @param {string} containerStyle
 * @param {string} paragraphStyle
 * @return {JSX.Element}
 * @constructor
 */
const DescriptionWithNewLines = ({
  description,
  containerStyle,
  paragraphStyle,
}) => {
  if (!description || description.length === 0) return null;
  return (
    <div className={containerStyle}>
      {description.split(/\n\n/).map((paragraph, index) => (
        <p className={paragraphStyle} key={index}>
          {paragraph.split("\n").map((line, lineIndex) => (
            <span key={lineIndex}>
              {line}
              <br />
            </span>
          ))}
        </p>
      ))}
    </div>
  );
};

export default DescriptionWithNewLines;
